import type { Dispatch, SetStateAction } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import Button from '@/components/Buttons/Button';
import type { FeedInfo } from '@/pages/Markets/MarketsComponents/Feed/types';

export const FeedLink = ({
  CTAType,
  CTAValue,
  CTALabel,
  open,
  setOpen
}: Pick<FeedInfo['values'], 'CTAValue' | 'CTAType' | 'CTALabel'> & {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  switch (CTAType) {
    case 'Catalog':
      return (
        <Link
          color='#E84E0F'
          component={RouterLink}
          sx={{ textDecoration: 'none' }}
          to={`../catalog/${CTAValue}`}
        >
          See in catalog
        </Link>
      );
    case 'Market':
      return (
        <Link
          color='#E84E0F'
          component={RouterLink}
          sx={{ textDecoration: 'none' }}
          to={`../markets/${CTAValue}`}
        >
          Go to market
        </Link>
      );
    case 'Symbol':
      return (
        <Button
          sx={{ color: '#E84E0F', p: 0, m: 0, minWidth: 0, border: 0, mt: '-3px' }}
          variant='text'
          onClick={() => {
            setOpen(v => !v);
          }}
        >
          See codes <ExpandMoreIcon style={{ margin: 0, rotate: open ? '180deg' : '0deg' }} />
        </Button>
      );
    case 'Link':
      return (
        <Link
          color='#E84E0F'
          href={CTAValue}
          sx={{ textDecoration: 'none' }}
          target='_blank'
        >
          {CTALabel ?? 'Read more'}
        </Link>
      );
    default:
      return null;
  }
};
